import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_ACTIVITY_LABELS = "activity-labels";

const getData = async (props: {
  token: string;
}): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/subscription-rules/activity-labels`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
    const item: any = res.data;
  return item.data;
};

export const useGetActivityLabels = () => {
  const { token, userInfo } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_ACTIVITY_LABELS],
    () => getData({
        token,
    }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );
  return queryData;
};
